export { Border, type BorderProps, type StoryblokBorderProps } from "./Border";
